// path/to/ReactScanComponent

"use client";
import { JSX, useEffect } from "react";

export function ReactScan(): JSX.Element {
    useEffect(() => {
        // Only enable if not explicitly disabled via environment variable.
        const isDisabled = process.env.NEXT_PUBLIC_DISABLE_REACT_SCAN === 'true';
        const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'dev';

        if (!isDisabled && isDev) {
            // Import lazily so react-scan is code-split out of the production bundle.
            import("react-scan").then(({ scan }) => scan({ enabled: true }));
        }
    }, []);

    return <></>;
}